var React = require('react');

function IconCheckmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.7364 5.11485L8.04971 16.2547L3.74081 11.9378L5.00917 10.7895L7.95954 13.7453L16.3886 4.05181L17.7364 5.11485Z","fill":"#6E767D"}));
}

IconCheckmark.defaultProps = {"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none"};

module.exports = IconCheckmark;

IconCheckmark.default = IconCheckmark;
